export default "__VITE_ASSET__e24a500b__"